import { useState } from "react";

import PropTypes from "prop-types";

import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import Img from "components/atoms/Img";
/* Components */
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FormNewsLetter from "components/molecules/FormNewsletter";
import AboutUs from "components/organisms/AboutUs";
import Banner from "components/organisms/Banner";
// Import BannerChristmas from "components/organisms/BannerChristmas";
import IndustryNewsInsights from "components/organisms/IndustryNewsInsights";
import OurPartners from "components/organisms/OurPartners";
import SupportedCountries from "components/organisms/SupportedCountries";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

const Component = ({ posts, countries, data }) => {
  const [screen, setScreen] = useState("DESKTOP");

  useResizeScreenModified(setScreen);

  return (
    <>
      <section>
        {/* <BannerChristmas /> */}
        <Banner
          minHeightBanner="banner-min-h-600"
          title="Helping you see real growth"
          description="We cover all grounds where you as startups, small business owners, CSPs are contemplating for. Global digital incorporation with ease, tech-enabled corporate services for efficient management. Get started to grow your business!"
          bgStyle={{
            backgroundBlendMode: "normal, overlay, normal, normal, normal",
          }}
          bgColor="bg-bbc-gradient-10 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]"
          isApplyCompanyForm={countries}
          leftClassName="relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40  "
          rightClassName="static hidden lg:block lg:col-6 xl:col-5 "
          wave={
            <div className="relative">
              <Img
                src="/assets/images/wave/exclude-wave.svg"
                className="h-full w-full"
                width={1920}
                height={95}
                wrapper={{
                  className: "w-full h-full",
                }}
                alt="banner-img"
              />
            </div>
          }
          rightContent={
            <>
              {screen === "DESKTOP" && (
                <Img
                  className="w-full "
                  wrapper={{
                    className: "bbc-banner-image-bottom-0 banner-home",
                  }}
                  src="/assets/images/offshore/home/banner-offshore-home.png"
                  width={1034}
                  height={720}
                  alt="tech-enabled offshore company registration service"
                  priority={true}
                />
              )}
            </>
          }
        ></Banner>
      </section>
      <IndustryNewsInsights data={posts} />
      <AboutUs data={data?.dataAboutUs} />
      <OurPartners />
      <section className="relative mb-0 pt-10 pb-6 lg:bg-bbc-brand-100 lg:pt-28 lg:pb-32">
        <Img
          className="absolute left-0 right-0 w-full"
          style={{ top: "-4px" }}
          src="/assets/images/wave/curve_home-wave.svg"
          width={1920}
          height={158}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave3"
        />
        <div className="container">
          <Title
            text="Our Services"
            className="mb-6 text-bbc-30px font-semibold text-bbc-brand-800 lg:text-bbc-40px"
          />
          <p className="leading-bbc-26 text-bbc-gray">
            We cover a wide range of digital corporate services to help your
            business get things done right from the start, and other supporting
            areas that keep it running smoothly during company operation.
          </p>
          <div className="row mt-6 items-center lg:mt-10">
            <div className="col-1 hidden lg:block" />
            <div className="col-12 lg:col-5">
              <div>
                <Title
                  as="h3"
                  text="Company Formation"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  We offer tech-based solutions of choice for your company
                  formation in over 18 markets spanned across continents. With a
                  full range of supporting corporate services, we can help you
                  easily establish and manage your company during your
                  operation.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/company-formation"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 mt-6 text-center lg:col-6 lg:mt-0">
              <Img
                src="/assets/images/offshore/home/company_formation-home-offshore.png"
                width={540}
                height={540}
                alt="company-formation"
              />
            </div>
          </div>
          <div className="row mt-6 items-center lg:mt-10">
            <div className="col-12 order-2 mt-6 text-center lg:col-6 lg:order-0 lg:mt-0">
              <Img
                src="/assets/images/offshore/home/bank_account-offshore-home.png"
                width={540}
                height={540}
                alt="bank-account"
              />
            </div>
            <div className="col-12 lg:col-5">
              <div>
                <Title
                  as="h3"
                  text="Bank Account Opening"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  We offer bank account introduction in offshore jurisdictions
                  as well as financial hubs in Asia where your money can be safe
                  and ready for global trading without currency control. A wide
                  banking network and a healthy long-term relationship with
                  international and offshore banks allow us to better serve
                  customers with various objectives.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/banking-support"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-1 hidden lg:block" />
          </div>
        </div>
      </section>
      <section className="relative mb-0 pb-10 lg:pt-0 lg:pb-20">
        <Img
          className="w-full"
          src="/assets/images/wave/curve_home1-wave.svg.svg"
          width={1920}
          height={116}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave4"
        />
        <div className="lg:-mt-52">
          <div className="container">
            <div className="row items-center">
              <div className="col-1 hidden lg:block" />
              <div className="col-12 lg:col-5">
                <div>
                  <Title
                    as="h3"
                    text="Accounting & Auditing"
                    className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                  />
                  <p className="mb-6 leading-bbc-26">
                    We&apos;re interested in keeping your resources low and your
                    numbers high. Get back precious time and resources for your
                    business with our cost-effective accounting and regulatory
                    compliance services.
                  </p>
                  <div className="text-center lg:text-left">
                    <Link
                      href="/accounting-and-auditing"
                      className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                    >
                      Explore
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 mt-6 text-center lg:col-6 lg:mt-0">
                <Img
                  src="/assets/images/common/accounting_auditing-offshore_vn.png"
                  width={540}
                  height={541}
                  alt="accounting-auditing"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <SupportedCountries
        title="Our Worldwide Supported Countries"
        description="Set up your business in over +15 countries and receive consultations
      from our local experts."
        data={data.supportedCountries}
      />
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 pb-0 text-center text-bbc-brand-800">
            Testimonials
          </Title>
          <p className="text-center">
            Clients talked about us on{" "}
            <a
              className="font-medium text-bbc-primary hover:text-bbc-secondary-300"
              target="_blank"
              rel="noreferrer"
              href="https://www.trustpilot.com/review/bbcincorp.com"
            >
              Trustpilot
            </a>
          </p>
          <TrustpilotFeedBack data={dataTrustpilot.feedback} />
        </div>
      </section>
      <FormNewsLetter />
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Component.defaultProps = {
  data: {},
  posts: [],
};
